
export default class CheckboxParam {
    constructor(el) {
        this.el = el;
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("click", (e) => {
            // e.preventDefault();
            this.handleChange();
        });
    }

    handleChange() {
        var key = this.el.dataset.param;
        
        let url = new URL(window.location);
        var params = new URLSearchParams(url.search);
        params.delete(key);
        params.delete("p");

        if(this.el.checked) {
            params.append(key, "true");
        }

        window.history.pushState(null, '', `${url.pathname}?${params.toString()}`);
    }
}